// Theme: cyan-ember
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cyan-ember',
  name: 'CYAN EMBER',
  tagline: 'CYAN EMBER',
  description: 'Ciano de alta energia com profundidade de brasa.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#050F10', '#0A1F22', '#075985', '#CFFAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-cyan-ember'
  },
  colorVars: {
    '--accent': '#075985',
    '--accent-foreground': '#050F10',
    '--background': '#050F10',
    '--border': '#0A5A6A',
    '--card': '#0A1F22',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#CFFAFE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#050F10',
    '--foreground': '#CFFAFE',
    '--hold-fill': '#075985',
    '--input': '#0A5A6A',
    '--modal-bg': '#050F10',
    '--modal-border': '#0A5A6A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#0A5A6A',
    '--muted-foreground': '#CFFAFE',
    '--nav-active': '#075985',
    '--nav-bg': '#0A1F22',
    '--popover': '#0A1F22',
    '--popover-foreground': '#CFFAFE',
    '--primary': '#075985',
    '--primary-foreground': '#050F10',
    '--ring': '#075985',
    '--secondary': '#0A5A6A',
    '--secondary-foreground': '#CFFAFE',
    '--streak': '#075985',
    '--success': '#22c55e',
    '--success-foreground': '#050F10',
    '--xp': '#075985',
    '--xp-bg': '#0A1F22'
  },
  resolvedVars: {
    '--accent': '#075985',
    '--accent-foreground': '#050F10',
    '--accent-foreground-hsl': '185 52% 4%',
    '--accent-foreground-oklch': 'from #050F10 l c h',
    '--accent-hsl': '201 90% 27%',
    '--accent-oklch': 'from #075985 l c h',
    '--background': '#050F10',
    '--background-hsl': '185 52% 4%',
    '--background-oklch': 'from #050F10 l c h',
    '--border': '#0A5A6A',
    '--border-hsl': '190 83% 23%',
    '--border-oklch': 'from #0A5A6A l c h',
    '--border-w': '1px',
    '--card': '#0A1F22',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#CFFAFE',
    '--card-foreground-hsl': '185 96% 90%',
    '--card-foreground-oklch': 'from #CFFAFE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '188 55% 9%',
    '--card-oklch': 'from #0A1F22 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#050F10',
    '--destructive-foreground-hsl': '185 52% 4%',
    '--destructive-foreground-oklch': 'from #050F10 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#CFFAFE',
    '--foreground-hsl': '185 96% 90%',
    '--foreground-oklch': 'from #CFFAFE l c h',
    '--hold-fill': '#075985',
    '--hold-fill-hsl': '201 90% 27%',
    '--hold-fill-oklch': 'from #075985 l c h',
    '--input': '#0A5A6A',
    '--input-hsl': '190 83% 23%',
    '--input-oklch': 'from #0A5A6A l c h',
    '--modal-bg': '#050F10',
    '--modal-bg-hsl': '185 52% 4%',
    '--modal-bg-oklch': 'from #050F10 l c h',
    '--modal-border': '#0A5A6A',
    '--modal-border-hsl': '190 83% 23%',
    '--modal-border-oklch': 'from #0A5A6A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#0A5A6A',
    '--muted-foreground': '#CFFAFE',
    '--muted-foreground-hsl': '185 96% 90%',
    '--muted-foreground-oklch': 'from #CFFAFE l c h',
    '--muted-hsl': '190 83% 23%',
    '--muted-oklch': 'from #0A5A6A l c h',
    '--nav-active': '#075985',
    '--nav-active-hsl': '201 90% 27%',
    '--nav-active-oklch': 'from #075985 l c h',
    '--nav-bg': '#0A1F22',
    '--nav-bg-hsl': '188 55% 9%',
    '--nav-bg-oklch': 'from #0A1F22 l c h',
    '--popover': '#0A1F22',
    '--popover-foreground': '#CFFAFE',
    '--popover-foreground-hsl': '185 96% 90%',
    '--popover-foreground-oklch': 'from #CFFAFE l c h',
    '--popover-hsl': '188 55% 9%',
    '--popover-oklch': 'from #0A1F22 l c h',
    '--primary': '#075985',
    '--primary-foreground': '#050F10',
    '--primary-foreground-hsl': '185 52% 4%',
    '--primary-foreground-oklch': 'from #050F10 l c h',
    '--primary-hsl': '201 90% 27%',
    '--primary-oklch': 'from #075985 l c h',
    '--radius': '12px',
    '--ring': '#075985',
    '--ring-hsl': '201 90% 27%',
    '--ring-oklch': 'from #075985 l c h',
    '--secondary': '#0A5A6A',
    '--secondary-foreground': '#CFFAFE',
    '--secondary-foreground-hsl': '185 96% 90%',
    '--secondary-foreground-oklch': 'from #CFFAFE l c h',
    '--secondary-hsl': '190 83% 23%',
    '--secondary-oklch': 'from #0A5A6A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#075985',
    '--streak-hsl': '201 90% 27%',
    '--streak-oklch': 'from #075985 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#050F10',
    '--success-foreground-hsl': '185 52% 4%',
    '--success-foreground-oklch': 'from #050F10 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(201 90% 27% / 0.15)',
    '--xp': '#075985',
    '--xp-bg': '#0A1F22',
    '--xp-bg-hsl': '188 55% 9%',
    '--xp-bg-oklch': 'from #0A1F22 l c h',
    '--xp-hsl': '201 90% 27%',
    '--xp-oklch': 'from #075985 l c h'
  }
}
